import { Box } from "@material-ui/core";
import React, { FC } from "react";
import { CreateButton, usePermissions } from "react-admin";
import { checkPermission } from "../../../helpers/checkPermissions";

const StaffUsersListTittle: FC = () => {
  const { permissions } = usePermissions()
  return (
    <Box marginTop="2em">
      <div className="active-prizes-container">Staff management</div>
      <Box display="flex" justifyContent="flex-end">
        {
          checkPermission(permissions, "Staff management", "Update") &&
          <CreateButton
            className="add-button"
            label="Add new "
            to="staffUsers/create"
          />
        }
      </Box>
    </Box>
  );
};

export default StaffUsersListTittle;
